import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParcelamentoComissaoService = {
    deletarExcelParametros(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'compensation/parcelamento-comissao/excel/deletar', 'excelParcelamentoComissaoDeletar');
    },
    parcelamentoComissaoExcelPost(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'compensation/parcelamento-comissao/excel', 'excelParcelamentoComissao');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> {
        return Client.getBlob('compensation/parcelamento-comissao/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> {
        return Client.post('compensation/parcelamento-comissao/eventGrid', {});
    }
};

export default ParcelamentoComissaoService;